import { MantineProvider } from '@mantine/core';
import { ContestType } from '@betterpool/api-types/contests-service';

import { PageLayout } from '~/domains/common/app/PageLayout';
import UnknownErrorScreen from '~/domains/common/components/UnknownErrorScreen/UnknownErrorScreen';

import {
  ContestContextProvider,
  useContestContext,
} from '../../domains/common/context/ContestContext/ContestContext';
import { SlatesContextProvider } from '../../domains/common/context/SlatesContext/SlatesContext';
import GamecenterPageLoadingStatesHandler from '../../domains/common/components/GamecenterPageLoadingStatesHandler/GamecenterPageLoadingStatesHandler';
import GamecenterEnabledCheck from '../../domains/common/components/GamecenterEnabledCheck/GamecenterEnabledCheck';
import TeamPickEmEntriesOverallPage from '../../domains/teamPickEm/pages/entries/overall';
import TeamSurvivorEntriesOverallPage from '../../domains/teamSurvivor/pages/entries/overall';
import GamecenterSupportedMobileOnlyCheck from '../../domains/common/components/GamecenterSupportedMobileOnlyCheck/GamecenterSupportedMobileOnlyCheck';
import PlayerTierEntriesOverallPage from '../../domains/playerTier/pages/entries/overall';
import PlayerSurvivorEntriesOverallPage from '../../domains/playerSurvivor/pages/entries/overall';

function EntriesOverallPageContent() {
  const { contest } = useContestContext();

  switch (contest.contest_type) {
    case ContestType.TEAM_SURVIVOR:
      return <TeamSurvivorEntriesOverallPage />;
    case ContestType.TEAM_PICK_EM:
      return <TeamPickEmEntriesOverallPage />;
    case ContestType.PLAYER_TIER:
    case ContestType.PLAYER_ONE_AND_DONE:
      return <PlayerTierEntriesOverallPage />;
    case ContestType.PLAYER_SURVIVOR:
      return <PlayerSurvivorEntriesOverallPage />;
    default:
      return (
        <PageLayout>
          <UnknownErrorScreen statusCode={404} />
        </PageLayout>
      );
  }
}

function GamecenterEntriesOverallPage() {
  return (
    <MantineProvider withNormalizeCSS withGlobalStyles inherit theme={{ colorScheme: 'light' }}>
      <ContestContextProvider>
        <GamecenterPageLoadingStatesHandler>
          <GamecenterEnabledCheck>
            <GamecenterSupportedMobileOnlyCheck screen="entries">
              <SlatesContextProvider ignoreQuery isStandings>
                <EntriesOverallPageContent />
              </SlatesContextProvider>
            </GamecenterSupportedMobileOnlyCheck>
          </GamecenterEnabledCheck>
        </GamecenterPageLoadingStatesHandler>
      </ContestContextProvider>
    </MantineProvider>
  );
}

export default GamecenterEntriesOverallPage;
